import * as React from 'react';

const PageLayout = ({ children , bottomContainerSlot ,  })=>{
    return /*#__PURE__*/ React.createElement(React.Fragment, null, children, /*#__PURE__*/ React.createElement("div", {
        className: "returns-bottom-container"
    }, bottomContainerSlot));
};
var PageLayout$1 = PageLayout;

export { PageLayout$1 as default };
//# sourceMappingURL=PageLayout.js.map
